var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDataLocked = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 165,
  height: 96,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#data_locked_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F5F5F5",
  d: "m87.82 9.034.551 3.646L2.697 25.79l-.55-3.646z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#data_locked_svg__b)",
  d: "m89.298 7.565 10.405 68.962L10.408 90.19.003 21.229z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F5F5F5",
  d: "m88.375 12.679 9.488 62.885-85.674 13.11L2.7 25.79z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF5252",
  d: "M85.119 11.312a.9.9 0 0 1 .75-1.027.896.896 0 0 1 1.02.756.9.9 0 0 1-.75 1.027.896.896 0 0 1-1.02-.756"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF0",
  d: "M82.685 11.683a.9.9 0 0 1 .75-1.027.896.896 0 0 1 1.02.756.9.9 0 0 1-.75 1.027.896.896 0 0 1-1.02-.756"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#69F0AE",
  d: "M80.252 12.057a.9.9 0 0 1 .75-1.027.896.896 0 0 1 1.02.756.9.9 0 0 1-.75 1.026.896.896 0 0 1-1.02-.755"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#data_locked_svg__c)",
  d: "M85.601 18.854 89.04 41.64 12.112 53.41 8.674 30.627z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4163A5",
  fillOpacity: 0.75,
  d: "m9.56 31.422 75.268-11.518 3.186 21.114-75.268 11.517z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#data_locked_svg__d)",
  d: "m77.245 52.455.665 4.406-5.129.784-.664-4.405z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4163A5",
  d: "m72.232 53.533 4.827-.739.55 3.646-4.827.739z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF5252",
  d: "M73.174 59.76 78 59.023l.55 3.646-4.826.739z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF9800",
  d: "m74.115 65.989 4.826-.739.55 3.646-4.826.739z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F5F5F5",
  d: "m72.955 1.643 90.041 20.269-.786 3.54L72.168 5.186z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#data_locked_svg__e)",
  d: "M71.216-.275 165 21.124l-14.678 67.029-93.784-21.399z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F5F5F5",
  d: "m72.17 5.187 90.041 20.268-13.559 61.085-90.041-20.268z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#data_locked_svg__f)",
  d: "m76.344 11.859 80.847 18.199-4.912 22.133-80.848-18.2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4163A5",
  fillOpacity: 0.75,
  d: "m76.94 12.922 79.103 17.806-4.552 20.509-79.104-17.806z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#data_locked_svg__g)",
  d: "m131.196 56.429 5.39 1.213-.95 4.278-5.389-1.213z",
  opacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF9800",
  d: "m128.066 69.147 5.094 1.151-.793 3.556-5.094-1.151z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4163A5",
  d: "m81.75 46.381 40.898 9.206-.458 2.066-40.898-9.206zM80.406 52.432l40.899 9.206-.459 2.066-40.898-9.206zM79.063 58.48l40.898 9.206-.459 2.066-40.898-9.206z",
  opacity: 0.4
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F5F5F5",
  d: "M29.036 3.428h104.636V7.88H29.036z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#data_locked_svg__h)",
  d: "M26.639 1.944h109.056v84.223H26.639z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M29.036 7.88h104.636v76.803H29.036z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#data_locked_svg__i)",
  d: "M35.299 14.744h93.951v27.828H35.299z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4163A5",
  fillOpacity: 0.75,
  d: "M36.22 15.857h91.925v25.787H36.22z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#data_locked_svg__j)",
  d: "M63.67 67.616h34.264V96H63.669z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#data_locked_svg__k)",
  d: "M90.024 63.103c0-2.563-1.01-5.02-2.81-6.833a9.56 9.56 0 0 0-6.785-2.83 9.56 9.56 0 0 0-6.785 2.83 9.7 9.7 0 0 0-2.81 6.833v6.183h-2.686v-6.183c-.02-1.637.283-3.262.892-4.78.608-1.518 1.51-2.9 2.652-4.064a12.3 12.3 0 0 1 4.002-2.72 12.2 12.2 0 0 1 9.47 0c1.5.631 2.86 1.556 4.003 2.72a12.4 12.4 0 0 1 2.652 4.064c.608 1.518.91 3.143.891 4.78v6.183h-2.686z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4163A5",
  d: "M89.644 62.978c0-2.46-.97-4.819-2.698-6.559a9.18 9.18 0 0 0-6.513-2.716 9.18 9.18 0 0 0-6.513 2.716 9.3 9.3 0 0 0-2.698 6.56v5.936h-2.58v-5.937c0-3.148 1.243-6.168 3.454-8.395a11.75 11.75 0 0 1 8.337-3.477c3.127 0 6.125 1.25 8.336 3.477a11.92 11.92 0 0 1 3.454 8.395v5.937h-2.58z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4163A5",
  d: "M64.403 68.544h32.054v26.343H64.403z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4163A5",
  d: "M64.403 68.544h32.054v26.343H64.403z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F5F5F5",
  d: "M65.024 74.034H95.91v15.458H65.024z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#data_locked_svg__l)",
  d: "M78.08 78.703a2.38 2.38 0 0 1 1.026-1.967 2.342 2.342 0 0 1 3.62 1.449 2.38 2.38 0 0 1-.593 2.14v5.049c0 .456-.18.894-.5 1.217a1.704 1.704 0 0 1-2.418 0c-.321-.323-.501-.76-.501-1.217v-5.05a2.37 2.37 0 0 1-.634-1.621"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M78.404 79.118a2.05 2.05 0 0 1 .886-1.69 2.02 2.02 0 0 1 3.119 1.244 2.05 2.05 0 0 1-.505 1.843v4.354c0 .394-.155.771-.431 1.05a1.47 1.47 0 0 1-2.085 0 1.5 1.5 0 0 1-.431-1.05v-4.354a2.05 2.05 0 0 1-.553-1.397",
  opacity: 0.2
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "data_locked_svg__b",
  x1: 55.055,
  x2: 44.505,
  y1: 83.359,
  y2: 14.419,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "gray",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "gray",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "gray",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "data_locked_svg__c",
  x1: -12513.1,
  x2: -13985.3,
  y1: 37278.8,
  y2: 27658,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "gray",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "gray",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "gray",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "data_locked_svg__d",
  x1: -2407.49,
  x2: -2426.46,
  y1: 3167,
  y2: 3042.98,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "gray",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "gray",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "gray",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "data_locked_svg__e",
  x1: -49391.6,
  x2: -43744.1,
  y1: 31310.6,
  y2: 6559.16,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "gray",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "gray",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "gray",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "data_locked_svg__f",
  x1: -36507.4,
  x2: -35898.7,
  y1: 1393.14,
  y2: -1310.8,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "gray",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "gray",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "gray",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "data_locked_svg__g",
  x1: -1921.39,
  x2: -1898.65,
  y1: 1778.32,
  y2: 1677.3,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "gray",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "gray",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "gray",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "data_locked_svg__h",
  x1: -49492.8,
  x2: -49492.8,
  y1: 39122.1,
  y2: 884.606,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "gray",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "gray",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "gray",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "data_locked_svg__i",
  x1: -42061.3,
  x2: -42061.3,
  y1: 6400.52,
  y2: 2226.45,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "gray",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "gray",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "gray",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "data_locked_svg__j",
  x1: -15563.3,
  x2: -15563.3,
  y1: 14755.6,
  y2: 10412.9,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "gray",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "gray",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "gray",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "data_locked_svg__k",
  x1: -14921.3,
  x2: -14921.3,
  y1: 10612.9,
  y2: 8742.58,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "gray",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "gray",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "gray",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "data_locked_svg__l",
  x1: -2790.74,
  x2: -2790.74,
  y1: 7193.12,
  y2: 6568.4,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "gray",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "gray",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "gray",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "data_locked_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M165 0H0v96h165z"
})))));
export default SvgDataLocked;